import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const FAQS = [
  { q: "Do I need any equipment or a gym?", a: "No. I bring everything we need and can train you with no equipment at all — on the living room rug, in the garden, at a park, or using kit you already own in the garage." },
  { q: "Which areas of Essex do you cover?", a: "I'm based in Chelmsford and cover much of Essex, including Braintree, Great Dunmow, Witham, Maldon, Billericay, Chipping Ongar, Wickford, Rayleigh, Basildon, Brentwood, South Woodham Ferrers, Canvey Island, Loughton and surrounding towns and villages." },
  { q: "Do you offer online coaching?", a: "Yes. Alongside mobile training in Essex, I offer online coaching nationwide and worldwide. Each client gets fully personalised workouts inside their own private client app, uploaded and adjusted by me as you progress." },
  { q: "Can you train people with health conditions, disabilities or older adults?", a: "Absolutely. I work with elderly clients (80+), stroke recovery, limited mobility, disabilities and rare conditions, adapting every session carefully to your ability and goals." },
  { q: "Do you help with nutrition too?", a: "Yes. Nutrition is half of any transformation. I provide simple, realistic guidance built around your life to support your training and long-term health." },
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 md:py-32 bg-[#0F172A]">
      <div className="mx-auto max-w-4xl px-5 md:px-10">
        <Reveal>
          <span className="font-mono-label text-[11px] text-[#FACC15]">Questions</span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-4">
            Good to <span className="text-[#FACC15]">know.</span>
          </h2>
        </Reveal>

        <div className="mt-12 divide-y divide-white/10 border-t border-white/10">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div className="py-2">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-question-${i}`}
                    className="w-full flex items-start justify-between gap-6 py-5 text-left group"
                  >
                    <span className="font-display text-xl md:text-2xl group-hover:text-[#FACC15] transition-colors duration-300">
                      {item.q}
                    </span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} className="shrink-0 mt-1 text-[#FACC15]">
                      <Plus size={22} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p data-testid={`faq-answer-${i}`} className="text-[#94A3B8] text-base leading-relaxed pb-6 pr-10">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
